import styled from 'styled-components'

export const HeaderWrapper = styled.div`
  padding: ${({ theme: { mp } }) => mp.xs} ${({ theme: { mp } }) => mp.sm};
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${({ theme: { palette } }) => palette.light};
  min-height: 50px;
  max-height: 60px;
  position: relative;
  background-color: ${(props) => props.theme.palette.white};
`

export const HeaderLogo = styled.div``

export const HeaderUser = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  cursor: pointer;

  &:before {
    position: absolute;
    content: '';
    height: 100%;
    background-color: ${({ theme: { palette } }) => palette.primary};
    width: 1px;
  }
`

export const HeaderUserName = styled.div`
  margin: 0 ${({ theme: { mp } }) => mp.sm};
`

export const HeaderUserAvatar = styled.div``

export const HeaderLogoImg = styled.img`
  max-height: 45px;
  &:hover {
    cursor: pointer;
  }
`

export const HeaderMenu = styled.div`
  width: 100%;
  height: auto;
  position: absolute;
  top: 110%;
  right: 0;
  background: white;
  cursor: auto;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 10;
`

export const HeaderMenuItem = styled.div`
  text-align: left;
  padding: ${({ theme: { mp } }) => mp.sm};
  cursor: pointer;
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  &:hover {
    background-color: ${({ theme: { palette } }) => palette.light};
  }
`

export const UserInfoEmail = styled.div`
  font-weight: ${({
    theme: {
      font: { weights },
    },
  }) => weights.thin};
  margin-bottom: ${({ theme: { mp } }) => mp.sm};
`

export const UserInfoName = styled.div`
  margin: ${({ theme: { mp } }) => mp.sm} 0;
`

export const MenuImg = styled.img`
  width: 20px;
  height: 20px;
  margin-right: ${({ theme: { mp } }) => mp.sm};
`

export const MenuIconWrapper = styled.div`
  margin-right: ${({ theme: { mp } }) => mp.sm};
`

export const MobileMenuWrapper = styled.div`
  overflow: auto;
  height: 100%;
  padding-top: ${({ theme: { mp } }) => mp.sm};
`

export const MenuHeader = styled.div`
  padding: ${({ theme: { mp } }) => mp.sm};
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${({ theme: { palette } }) => palette.light};
`

export const MenuSubHeader = styled.div`
  padding: ${({ theme: { mp } }) => mp.sm};
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${({ theme: { palette } }) => palette.light};
`

export const StyledMenu = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme: { palette } }) => palette.white};
  height: 100%;
`

export const MenuHeaderLeft = styled.div``

export const MenuHeaderRight = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${(props) => props.theme.font.sizes.large};
`
